import { takeLatest, select, call, put } from 'redux-saga/effects'
import { SET_PAYMENT_HISTORY, PAYMENT_HISTORY } from '../actions/type'
import { getHttpClient, getSelector, genVRoomToken } from '../../helpers'
import { showSpinner, hideSpinner } from '../actions/actions'
import { isEmpty } from 'lodash'

const keycloakSelector = getSelector('keycloak')

function* getHistoryList() {
    yield put(showSpinner)
    const keycloak = yield select(keycloakSelector)
    if (!isEmpty(keycloak)) {
        try {
            const token = yield call(genVRoomToken, keycloak)
            const url = `${window._env_.subscriberServiceBaseURL}/v1/paymentHistory`
            const header = {
                Authorization: `Bearer ${token}`
            }
            const paymentHistory = yield call(getHttpClient, keycloak, url, header)
            const paymentHistoryList = paymentHistory.data
            console.log(paymentHistoryList);
            paymentHistoryList.sort((a, b) => {
                if (a.dueDate > b.dueDate)
                    return -1
                if (a.dueDate < b.dueDate)
                    return 1
                return 0
            })
            console.log(paymentHistoryList);
            yield put({
                type: SET_PAYMENT_HISTORY,
                payload: { paymentHistoryList: paymentHistoryList }
            })
        } catch (err) {
            // Do not any thing
        }
    }
    yield put(hideSpinner)
}

function* paymentHistorySaga() {
    yield takeLatest(PAYMENT_HISTORY, getHistoryList)
}

export default paymentHistorySaga